import { TableColumn } from '@maersk-global/mds-components-core/mc-table/types';

export const columns: TableColumn[] = [
  { id: 'day', label: 'Day', align: 'left', sortDisabled: true, width: '200px' },
  { id: 'hours', label: 'Hours', align: 'left', sortDisabled: true },
  { id: 'remarks', label: 'Remarks', align: 'left', sortDisabled: true },
  { id: 'actions', label: 'Actions', align: 'right', sortDisabled: true, width: '200px' },
];

export const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
